import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic } from '@fortawesome/pro-regular-svg-icons';
import { Button, FlexBox } from '@eltoro-ui/components';
import BannerMobileModal from 'Pages/CampaignCreation/components/GeneratedCampaign/GeneratedCampaignContent/BannerMobileModal';
import { GenBannerType, GeneratedCampaignType } from 'types';
import './GeneratedCreatives.scss';

type GeneratedCreativesMobileProps = {
  campaignData?: GeneratedCampaignType;
};
const GeneratedCreativesMobile = ({ campaignData }: GeneratedCreativesMobileProps) => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const [clickedBanner, setClickedBanner] = useState<GenBannerType | null>(null);
  const history = useHistory();
  const addressList = [
    campaignData?.listing?.street,
    campaignData?.listing?.city,
    campaignData?.listing?.state,
    campaignData?.listing?.zip,
  ];
  return (
    <div className="mobile-creative-container">
      <h3 className="creative-heading">Review Banners</h3>
      <p className="listing-address">
        Review the generated ads for your campaign Listing address:
        {addressList.join(', ')}
      </p>
      <FlexBox UNSAFE_className="image-section">
        {campaignData?.gen_banners?.map(banner => (
          <button
            key={banner.banner_uuid}
            className="image-wrapper"
            onClick={() => setClickedBanner(banner)}
          >
            <img src={banner.presigned_url} alt={banner.banner_uuid} className="image-preview" />
          </button>
        ))}
      </FlexBox>
      <FlexBox flexDirection="column" alignItems="center">
        <p className="edit-question">Want to make changes to ads?</p>
        <Button
          kind="link"
          weight="bold"
          UNSAFE_className="edit-ai-btn"
          iconLeft={<FontAwesomeIcon icon={faMagic} />}
          onClick={() =>
            history.push(`/landing/${campaignId}`, {
              is_reminded: campaignData?.campaign.is_reminded,
              notification_id: campaignData?.campaign.notification_id,
            })
          }
        >
          Edit with AI
        </Button>
      </FlexBox>
      {clickedBanner && campaignData && (
        <BannerMobileModal banner={clickedBanner} onClose={() => setClickedBanner(null)} />
      )}
    </div>
  );
};

export default GeneratedCreativesMobile;
